// © Microsoft Corporation. All rights reserved.
import { SubscribableMap } from "./SubscribableMap";
import { registerDataMessageHandler } from "./MessageHandler";
import { sendMessage } from "./PostMessage";
export const webWorkerCache = new SubscribableMap();
/**
 * Registers handler to return data from web worker cache.
 * This is the default data message handler unless a handler is registered for a specific message Id
 */
function initialize() {
    registerDataMessageHandler("default", returnCachedData);
}
/**
 * Web worker cache data message handler.
 * For the given id, returns the value in cache.
 * @param message - The message
 */
function returnCachedData(message) {
    const { id } = message;
    const item = webWorkerCache.get(id);
    if (!item) {
        sendMessage({ id, fetched: false, payload: null });
        return;
    }
    sendMessage({ id, fetched: true, payload: item.payload });
}
initialize();
//# sourceMappingURL=WebWorkerCache.js.map